import {createContext} from 'react';

import type {BackgroundTaskContextType} from './typedef';
import type {Context} from 'react';

const DEFAULT_CONTEXT = {
    createBackgroundTask: () => null,
    completeBackgroundTask: () => undefined,
};

export const BackgroundTaskContext: Context<BackgroundTaskContextType> = (
    createContext<BackgroundTaskContextType>(DEFAULT_CONTEXT)
);
